const PREFIX = '[AppConfig]'

let _cached = null

export function getAppConfig() {
  if (_cached) return _cached

  const win = window.__APP_CONFIG__
  const hasWindow = win !== null && typeof win === 'object'

  function resolve(winKey, envKey, fallback) {
    if (hasWindow) {
      const v = win[winKey]
      if (v !== undefined && v !== '') return v
    }
    const e = process.env[envKey]
    if (e !== undefined && e !== '') return e
    return fallback
  }

  const apiBaseUrl    = resolve('apiBaseUrl',    'VUE_APP_API_BASE_URL',      '/api')
  const auth0Domain   = resolve('auth0Domain',   'VUE_APP_AUTH0_DOMAIN',      undefined)
  const auth0ClientId = resolve('auth0ClientId', 'VUE_APP_AUTH0_CLIENT_ID',   undefined)
  const auth0Audience = resolve('auth0Audience', 'VUE_APP_AUTH0_AUDIENCE',    undefined)
  const rawMock       = resolve('useMockData',   'VUE_APP_USE_MOCK_DATA',     false)
  const useMockData   = rawMock === true || rawMock === 'true'

  const source = hasWindow ? 'window.__APP_CONFIG__' : 'process.env'
  console.log(`${PREFIX} source=${source} apiBaseUrl=${apiBaseUrl}`)

  _cached = Object.freeze({ apiBaseUrl, auth0Domain, auth0ClientId, auth0Audience, useMockData })
  return _cached
}
